import React from 'react';
import PropTypes from 'prop-types';

import './FieldRadioGroup.sass';

import cx from 'classnames';

import FieldRadio from '../fieldRadio/FieldRadio';

export default function FieldRadioGroup({input, meta: {touched, error} = {}, label, className, choices, required}) {
  const displayError = (touched && error);

  return (
    <fieldset className={cx('field-radio-group', className)}>
      {label && <legend className="field-radio-group__title">{label}</legend>}

      {choices.map(choice => (
        <FieldRadio
          key={choice.code}
          name={input.name}
          value={choice.code}
          checked={choice.code === input.value}
          onChange={input.onChange}
          required={required}
        >
          {choice.label}
        </FieldRadio>
      ))}

      {displayError && (<div className="field-radio-group__error-message">{error}</div>)}
    </fieldset>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldRadioGroup/FieldRadioGroup.js